<template>
  <v-app  >
      <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <section class="ma-4">
      <v-row justify="center" align="center">
        <v-col cols="10">
          <v-row>
        <v-col v-for="fiesta in fiestas" :key="fiesta.id" cols="12" lg="4" md="4" sm="12">
          <v-card color="#F2E7D5" elevation="10">
            <v-card-text><v-img :src="fiesta.fiestaEntity.foto"  @click="iraSortear(fiesta.fiestaEntity)"></v-img></v-card-text>
            <v-card-title><a @click="iraSortear(fiesta.fiestaEntity)">{{fiesta.fiestaEntity.nombre}}</a></v-card-title>

          </v-card>
        </v-col></v-row></v-col>
      </v-row>
      </section>
    </v-main>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
<piepagina />
  </v-app>
</template>

<script>

import axios from 'axios';
import Cabecera from "@/components/general/cabecera";
import Piepagina from "@/components/general/piepagina";
import Cabecerabaja from "@/components/general/cabecerabaja";
import {mapGetters} from "vuex";
import firebase from 'firebase/compat/app';

export default {
  name: "sorteo",
  components: {Cabecerabaja, Piepagina, Cabecera},
  data () {
    return {
      tagevento:'',
      alertnuevo: false,
      campoapmaterno: false,
      token:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      inscritos:[],
      rest: false,
      overlay:false,
      currentIndex:0,
      interval:0,
      paisId:0,
      tag:'',
      autoplay:true,
      referido:'',
      fiestas:[]
    }
  },

  mounted () {
    this.tag = this.$route.params.tag
    if(this.usuario.id>0){
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.dameFiestasActivas();
    }else{
      this.$router.push({ path: '/' });

    }
  },
  methods: {
    iraSortear(item){

      this.$router.push({name:"fiestasortear", params:{tag: this.tag, fiesta: item}})
    },
    dameFiestasActivas(){
      this.overlay = true
      axios
          .get('actos/fiestas/activas/'+this.tag,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            this.fiestas = response.data;
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    }

  },
  computed:{
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>
